<template>
  <component :is="as" class="link-wrapper">
    <a v-if="isExternalLink" class="link-wrapper__link" :href="to" target="_blank" rel="noopener noreferrer">
      <slot />
    </a>
    <nuxt-link v-else class="link-wrapper__link" :to="to" no-prefetch>
      <slot />
    </nuxt-link>
  </component>
</template>

<script setup lang="ts">
import { AllowedTags } from '~/types';

type Props = {
  as?: AllowedTags;
  isExternalLink?: boolean;
  linkUrl?: string | Record<string, any>;
};

const props = withDefaults(defineProps<Props>(), {
  as: 'div',
  isExternalLink: false,
  linkUrl: '',
});

const to = computed(() => {
  if (props.isExternalLink) return `https://${props.linkUrl}`;
  if (typeof props.linkUrl !== 'string') return props.linkUrl;
  return encodeURI(decodeURI(props.linkUrl).split(' ').join('+'));
});
</script>
<script lang="ts">
export default defineComponent({
  name: 'LinkWrapper',
});
</script>

<style lang="scss">
.link-wrapper {
  &__link {
    z-index: 1;
    width: 100%;
  }

  &:has(&__link:focus-visible) {
    outline: -webkit-focus-ring-color solid 2px !important;
  }
}

.linkWrapper {
  z-index: 1;
  width: 100%;
}
</style>
